import { call, put } from 'redux-saga/effects';
import { configurationSaga } from '../api/repositories/configuration';
import {
  generateBlackboxSuccess,
  getConfigurationsSuccessAction,
} from './actions';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const iovationClient = require('iovation-client').default;

export function* getConfigurationsSaga() {
  const response = yield call(configurationSaga);

  yield put(getConfigurationsSuccessAction(response));
}

export function* generateBlackboxString() {
  const blackbox = yield call(iovationClient);

  yield put(generateBlackboxSuccess({ blackbox }));
}
